import { Box, SxProps, Theme } from "@mui/material";
import { ElementType, ReactNode } from "react";
import { FONT_UI } from "@/src/components/common/broadsheet/tokens";

export default function Kicker({
  children,
  component = "div",
  color = "custom.kicker",
  sx,
  ...rest
}: {
  children: ReactNode;
  component?: ElementType;
  color?: string;
  sx?: SxProps<Theme>;
  id?: string;
  htmlFor?: string;
}) {
  return (
    <Box
      component={component}
      {...rest}
      sx={[
        {
          fontFamily: FONT_UI,
          fontSize: "0.6875rem",
          fontWeight: 600,
          letterSpacing: "0.16em",
          textTransform: "uppercase",
          lineHeight: 1.4,
          color,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Box>
  );
}
